const TeamCard = ({ heading, description, image }) => {
  return (
    <div class="tw-relative tw-flex tw-h-full tw-flex-col tw-items-start tw-justify-between tw-overflow-hidden" tabindex="0">
      <img
          className={`tw-size-full tw-object-cover tw-object-top`}
          src={image}
          alt={''}
          loading="lazy"
      />

      <div class="tw-absolute tw-bottom-32 tw-pl-32 tw-pr-[1.125rem]">
        <h4 class="tw-mb-8 tw-text-left tw-text-24 tw-font-bold tw-capitalize tw-text-white tablet:tw-text-[30px]">{heading}</h4>
        <div class="tw-text-left tw-text-14 tw-font-semibold tw-text-white tablet:tw-text-16">
          { description }
        </div>
      </div>
    </div>
  );
};

export default TeamCard;